import tokens from '@timelyapp/design-system/tokens.json';
import { Box, Text } from '@timelyapp/react';
import InlineMessage from 'components/InlineMessage';
import React from 'react';
import { useSelector } from 'react-redux';
import type { AppImportOptions } from 'redux/modules/apps.types';
import { getAppsDraft, getHasAppAccountOptions } from 'redux/selectors/apps';
import styles from './Options.module.scss';
import SyncOptionsSection from './SyncOptionsSection';

const AsanaOptions: React.FC = () => {
  const draft = useSelector(getAppsDraft);
  const options = draft.options as AppImportOptions | null;
  const hasOptions = useSelector(getHasAppAccountOptions);

  const syncAllMessage = options?.sync_all != null && (
    <>
      {options?.sync_all
        ? 'All existing and any later added project in Asana will be imported and synced.'
        : `Only selected Asana ${
            options?.parent_source === 'workspace' ? 'workspaces' : 'projects'
          } will be synced.`}
      <br />
    </>
  );

  return (
    <>
      <form
        className={styles.container}
        onSubmit={e => {
          e.preventDefault();
        }}
      >
        <Box.Column gap="large" alignItems="flex-start">
          <SyncOptionsSection
            hasOptions={hasOptions}
            draftOptions={options}
            entityName="projects"
            childSource="project"
            parentSource="workspace"
          />
          <InlineMessage type="warning" style={{ marginTop: tokens.theme_spacing_05 }}>
            {!hasOptions ? (
              <Text size="small">
                {syncAllMessage}
                You will not be able to change any of these settings later.
              </Text>
            ) : (
              <>
                You must disconnect the integration and connect it again to modify settings after
                connecting.
              </>
            )}
          </InlineMessage>
        </Box.Column>
      </form>
    </>
  );
};

export default AsanaOptions;
